// The Studio API base the CD screens read as `window.__STUDIO_API_BASE__`.
//
// It has to be set before any screen module evaluates. Several of them capture it
// at module top level (`const ACCT = { baseUrl: window.__STUDIO_API_BASE__ ?? "" }`
// in AccountDetails, access.ts, nj-binding.ts, the dashboard pacing card), and ES
// modules evaluate their imports before their own body. While main.tsx set the
// global in its body, `import { App }` had already evaluated every one of those
// modules, so they captured "" and fetched same-origin. The Studio host answers a
// /v1 path with the SPA's own index.html, so each of those reads failed to parse.
//
// main.tsx imports this module second, after signin-url and before anything that
// reaches a screen, so the global exists before the first reader evaluates.
//
// The value is the tenant API origin the rest of the client already resolves from
// the composer-generated env. Plain origin, no `/t/<slug>` segment: the routes
// these clients call are mounted directly on the events worker, and the clients
// compose `${baseUrl}${path}` with `path` carrying the full route. With no env
// value (a design-time build), the global stays unset and the same-origin MSW
// behaviour is untouched.
export function applyStudioApiBase(base: string | undefined, target: { __STUDIO_API_BASE__?: string }): void {
  const value = (base ?? "").trim();
  if (value) target.__STUDIO_API_BASE__ = value;
}

if (typeof window !== "undefined") {
  applyStudioApiBase(
    import.meta.env.VITE_EVENTS_API_BASE_URL as string | undefined,
    window as { __STUDIO_API_BASE__?: string },
  );
}
